import { addToCartAction, createNewCartAction } from "@/actions/cart";
import { MarketConfiguration } from "@/config/markets/const";
import { getCartCookie } from "@/utils/cart/getCartCookie";
import { CustomProduct } from "@apptus/esales-api";
import { setCartCookie } from "@server/utils/cart";
import createCartInputItem from "./createCartItem";

export type AddToCartInput = {
  product: CustomProduct;
  quantity: number;
}[];

export default async function addToCart(
  input: AddToCartInput,
  marketConfig: MarketConfiguration,
) {
  const cartId = getCartCookie()?.value;
  const tickets: string[] = [];
  const items = input.map((item) => {
    const { product, quantity } = item;
    const [variant] = product.variants;

    if (variant?.ticket) {
      tickets.push(variant.ticket);
    }

    return createCartInputItem({
      marketConfig,
      product,
      quantity,
    });
  });

  if (!cartId) {
    const newCart = await createNewCartAction({
      items,
      locale: marketConfig.serviceLocale,
    });

    if (newCart instanceof Error) {
      throw new Error("Failed to create new cart");
    }

    void setCartCookie({
      id: newCart.id.toString(),
      token: newCart.token,
    });

    return newCart;
  }
  return addToCartAction({
    cartId,
    items,
    locale: marketConfig.serviceLocale,
  });
}
